import "./App.css"
import ManagementRoute from "./components/management-route"
import "./hooks/varsLight.css"

function App() {
  return (
    <div className='App'>
      <ManagementRoute />
    </div>
  )
}

export default App
